import { defineMessages } from 'react-intl';

export const alertModalMessages = defineMessages({
  title: {
    defaultMessage: 'Duties & Taxes May Apply',
    id: 'SXnWCq',
    description: 'alertModalMessages.title',
  },
  message: {
    defaultMessage:
      '<p>Your customer may be required to pay duties, taxes, and other fees before they can receive this shipment.</p><p>Prepay these duties and taxes with one flat fee to save both you and your customers time and money.</p><p>To opt-in, choose <strong>Change Duties/Taxes</strong>. To proceed without making any changes, choose <strong>Proceed to Label</strong>.</p>',
    id: 'JsFPAB',
    description: 'alertModalMessages.message',
  },
  changeButton: {
    defaultMessage: 'Change Duties/Taxes',
    id: 'S5a3z8',
    description: 'alertModalMessages.changeButton',
  },
  proceedButton: {
    defaultMessage: 'Proceed to Label',
    id: 'Kgwvxf',
    description: 'alertModalMessages.proceedButton',
  },
});

export const bannerMessages = defineMessages({
  title: {
    defaultMessage: 'Prepay Duties and Taxes',
    id: 'gNskn3',
    description: 'bannerMessages.title',
  },
  message: {
    defaultMessage:
      'Save yourself and your recipient time and money by prepaying Canadian duties & taxes with a flat fee. <a>Learn more</a>',
    id: 'nwR/wM',
    description: 'bannerMessages.message',
  },
});

export const bulkAlertModalMessages = defineMessages({
  title: {
    defaultMessage: 'Duties & Taxes May Apply',
    id: 'fb44Du',
    description: 'bulkAlertModalMessages.title',
  },
  message: {
    defaultMessage:
      '<p>There {count, plural, one {is # selected shipment} other {are # selected shipments}} that your customers may be required to pay duties, taxes, and other fees on before they can receive the {count, plural, one {shipment} other {shipments}}. You can save yourself and your customers time and money by prepaying these duties and taxes with one flat fee as low as $7.95 per shipment.</p><p>To opt-in, <strong>select the “Prepay Duties and Taxes” option</strong>.</p>',
    id: 'st2kN1',
    description: 'bulkAlertModalMessages.message',
  },
  errorMessage: {
    defaultMessage: '<strong>Opt-in Unsuccessful</strong>. We were unable to apply your selection. Click Continue to try again.',
    id: 'qSuY/o',
    description: 'bulkAlertModalMessages.errorMessage',
  },
  prepayDutiesCheckboxSingleCase: {
    defaultMessage: 'Prepay Duties and Taxes ({ddpPrice} per label) for {count, plural, one {# shipment} other {# shipments}}',
    id: 'B4+yi1',
    description: 'bulkAlertModalMessages.prepayDutiesCheckbox single price case',
  },
  prepayDutiesCheckboxMulitpleCase: {
    defaultMessage:
      'Prepay Duties and Taxes at {ddpPrice1} per label for {count1, plural, one {# shipment} other {# shipments}} and {ddpPrice2} per label for {count2, plural, one {# shipment} other {# shipments}}',
    id: 'jxfZoU',
    description: 'bulkAlertModalMessages.prepayDutiesCheckbox multiple price case',
  },
  autoPrepayDutiesCheckbox: {
    defaultMessage: 'Apply "Prepay Duties and Taxes" automatically to future orders',
    id: 'pl7Yon',
    description: 'bulkAlertModalMessages.autoPrepayDutiesCheckbox',
  },
  cancelButton: {
    defaultMessage: 'Cancel',
    id: '9sKN9e',
    description: 'bulkAlertModalMessages.cancelButton',
  },
  continueButton: {
    defaultMessage: 'Continue',
    id: 'ZTtHYF',
    description: 'bulkAlertModalMessages.continueButton',
  },
  failedToCreateAutomationRuleTitle: {
    defaultMessage: 'Failed to Create Duties and Taxes Automation Rule',
    id: 'EGOSs5',
    description: 'bulkAlertModalMessages Failed to create Automation rule title',
  },
  successfullyCreatedAutomationRuleTitle: {
    defaultMessage: 'Successfully Created Duties and Taxes Automation Rule',
    id: 'Bxsnb0',
    description: 'bulkAlertModalMessages Successfully created Automation rule title',
  },
});

export const dutiesAndTaxesMessages = defineMessages({
  label: {
    defaultMessage: 'Duties/Taxes',
    id: 'Z0BnsN',
    description: 'dutiesAndTaxesMessages.label',
  },
  learnMoreLinkMessage: {
    defaultMessage: 'Avoid surprise charges by prepaying duties/taxes with a flat fee. <a>Learn more</a>',
    id: 'HFglIH',
    description: 'dutiesAndTaxesMessages.learnMoreLinkMessage',
  },
  recipientPaysOption: {
    defaultMessage: 'Recipient Pays on Delivery',
    id: '0XVzdV',
    description: 'dutiesAndTaxesMessages.recipientPaysOption',
  },
  prepayDutiesOption: {
    defaultMessage: 'Prepay Duties and Taxes {ddpPrice}',
    id: 'lsbNxC',
    description: 'dutiesAndTaxesMessages.prepayDutiesOption',
  },
  prepayDutiesOptionWithoutPrice: {
    defaultMessage: 'Prepay Duties and Taxes',
    id: 'V2R8ry',
    description: 'dutiesAndTaxesMessages.prepayDutiesOption wihtout price',
  },
});
